import Swal from 'sweetalert2'
import apiClient from '../apiClient'

export async function verifyPin(action: string, actionDetail?: string): Promise<boolean> {
    const { value: pin } = await Swal.fire({
        title: 'PIN CODE',
        html: '<input id="pin-input" type="password" class="swal2-input" placeholder="กรอก PIN">',
        focusConfirm: false,
        confirmButtonText: 'ตกลง',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        preConfirm: () => (document.getElementById('pin-input') as HTMLInputElement).value
    })
    if (!pin) return false

    try {
        const res = await apiClient.post('/v1/verify-pin', { pin, action, action_detail: actionDetail || '' })
        if (res.data.result === 'success') return true
        Swal.fire({ icon: 'error', title: 'PIN CODE ไม่ถูกต้อง', showConfirmButton: false, timer: 1500 })
        return false
    } catch {
        Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', showConfirmButton: false, timer: 1500 })
        return false
    }
}
